<template>
    <div class="w-2/6 m-auto">
        <form @submit.prevent="submit">
            <div>
                <breeze-label for="password_old" :value="__('Password_old')" />
                <breeze-input id="password_old" type="password" class="mt-1 block w-full" v-model="form.password_old" required autocomplete="current-password" autofocus />
                <p class="text-red-500 text-xs" :class="{'invisible':!form.errors.password_old}">{{ __(form.errors.password_old) }}</p>
            </div>
            <div>
                <breeze-label for="password_new" :value="__('Password_new')" />
                <breeze-input id="password_new" type="password" class="mt-1 block w-full" v-model="form.password_new" required autocomplete="new-password" />
                <p class="text-red-500 text-xs" :class="{'invisible':!form.errors.password_new}">{{ __(form.errors.password_new) }}</p>
            </div>
            <div>
                <breeze-label for="password_new_confirmation" :value="__('Password_new_confirmation')" />
                <breeze-input id="password_new_confirmation" type="password" class="mt-1 block w-full" v-model="form.password_new_confirmation" required autocomplete="new-password" />
                <p class="text-red-500 text-xs" :class="{'invisible':!form.errors.password_new_confirmation}">{{ __(form.errors.password_new_confirmation) }}</p>
            </div>
            <p class="text-center my-2 text-green-700 font-semibold" v-if="$page.props.flash.succes">{{ __($page.props.flash.succes) }}</p>
            <p class="text-center my-2 text-red-700 font-semibold" v-else-if="$page.props.flash.erreur">{{ __($page.props.flash.erreur) }}</p>
            <div class="flex justify-center mt-4">
                <breeze-button class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                    {{ __('confirmer') }}
                </breeze-button>
            </div>
        </form>
    </div>
</template>

<script>
import App from "@/Layouts/App"
import BreezeButton from '@/Components/Button'
import BreezeInput from '@/Components/Input'
import BreezeLabel from '@/Components/Label'
import BreezeValidationErrors from '@/Components/ValidationErrors'

export default {
    layout: App,
    name: "EditionPassword",
    components: {
        BreezeButton,
        BreezeInput,
        BreezeLabel,
        BreezeValidationErrors,
    },
    data: function () {
        return {
            form: this.$inertia.form({
                password_old: '',
                password_new: '',
                password_new_confirmation: '',
            }),
        }
    },
    methods: {
        submit: function() {
            this.form.post(this.route('utilisateur.enregistrer.mot_de_passe'), {
                onFinish: () => this.form.reset('password_old', 'password_new', 'password_new_confirmation'),
            });
        }
    }
}
</script>

<style scoped>

</style>
